import React from 'react';
import {
    BrowserRouter as Router,
    Route,
} from "react-router-dom";
import './i18n/i18n';
import OnBoardToNwc from './components/OnBoardToNwc';
import OnBoardToNwc2 from './components/OnBoardToNwc2';
import ConnectedUserLanding from './components/ConnectedUserLanding';

export default function App() {
    return (
        <Router>
            <Route path="/Landing">
                <OnBoardToNwc />
            </Route>
            <Route path="/LandingNwc">
                <OnBoardToNwc2 />
            </Route>
            <Route path="/LandingNwcForms">
                <ConnectedUserLanding />
            </Route>
        </Router>
    );
}
